/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_Confirmdiscard1Inputs */



/**

* @param {_Wiki_Confirmdiscard1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _wiki_confirmdiscard1 = /** @type {((inputs?: _Wiki_Confirmdiscard1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_Confirmdiscard1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Änderungen verwerfen?")
});
export { _wiki_confirmdiscard1 as "_wiki_confirmDiscard" }